import API from "Services/Api";


export const updatePersonBudget = async (budget_id: number, person_id: number) => {

  try {
    const response = await API.post(`/budgets/${budget_id}/update_person/${person_id}`);

    return response.data

  } catch (err) {
    console.error(err);
    throw "Ops! Ocorreu um erro ao atualizar o orçamento";
  }

}